import { useEffect, useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getProfile } from "../redux/userManagementSlice";
import { getLoginAsUserNameFromLocalStorage } from "../components/loginasuser/LoginAsUser";
import { refreshHeader } from "../locales/en";

const useProfile = () => {
  const dispatch = useDispatch();
  const { profile, profileLoading } = useSelector(
    (state) => state.userManagement
  );
  const [profileName, setProfileName] = useState("");

  const fetchProfile = useCallback(async () => {
    const response = await dispatch(getProfile()).unwrap();
    return response?.data?.data || response;
  }, [dispatch]);

  useEffect(() => {
    if (!profile || Object.keys(profile).length === 0) {
      fetchProfile();
    }
  }, [profile]);

  useEffect(() => {
    const updateProfileName = () => {
      const storedLoginAsName = getLoginAsUserNameFromLocalStorage();

      const profileName =
        (profile?.userAccountMeta?.displayName &&
          profile.userAccountMeta.displayName.trim()) ||
        storedLoginAsName ||
        profile?.displayName;
      setProfileName(profileName);
    };

    updateProfileName();

    window.addEventListener(refreshHeader, updateProfileName);
    return () => {
      window.removeEventListener(refreshHeader, updateProfileName);
    };
  }, [profile]);

  return {
    profile,
    profileName,
    loading: profileLoading,
    refreshProfile: fetchProfile
  };
};

export default useProfile;
